import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationUpgradeModule } from '@angular/common/upgrade';
import { UpgradeModule } from '@angular/upgrade/static';
import { defaultThemes } from '../common/enums/themes.enum';
import { StateMockService } from '../common/services/state-mock/StateMockService';
import * as angular from 'angular';

export const debootstrapLegacyForTesting = () => {
    angular.element(document.body).data('$injector', null);
};

export const initLegacy = (upgradeModule: UpgradeModule) => {
    try {
        angular.module('app.areas.common')
            .provider(StateMockService.$name, StateMockService);

        upgradeModule.bootstrap(document.body as any, [
            'app.areas.devices',
        ]);
    } catch (e) {
        //  do nothing
    }
};

@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        UpgradeModule,
        LocationUpgradeModule.config(),
    ],
    providers: [
    ],
    exports: [
    ]
})
export class LegacyModule {
    constructor(upgrade: UpgradeModule,
                @Optional() @SkipSelf() parentModule: LegacyModule) {
        if (parentModule) {
            throw new Error(
                'LegacyModule is already loaded. Import it in the CasModule only');
        }
        LegacyModule.initLegacy(upgrade);
    }

    public static initLegacy(upgrade: UpgradeModule): void {
        angular
            .module('app.areas.devices')
            .config(['$mdThemingProvider', '$provide', ($mdThemingProvider, $provide) => {
                $mdThemingProvider.generateThemesOnDemand(true);
                $provide.value('themeProvider', $mdThemingProvider);
            }])
            .factory('defaultTheme', () => {
                const theme = localStorage.getItem('theme');
                return theme === 'dark' ? defaultThemes.dark : defaultThemes.light;
            });

        initLegacy(upgrade);
    }

    public static forRoot(): ModuleWithProviders<LegacyModule> {
        return {
            ngModule: LegacyModule,
            providers: [
            ]
        };
    }
}




